var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/drinks"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.5C5.91421 1.5 6.25 1.83579 6.25 2.25V4C6.25 4.41421 5.91421 4.75 5.5 4.75C5.08579 4.75 4.75 4.41421 4.75 4V2.25C4.75 1.83579 5.08579 1.5 5.5 1.5ZM9.5 1.5C9.91421 1.5 10.25 1.83579 10.25 2.25V4C10.25 4.41421 9.91421 4.75 9.5 4.75C9.08579 4.75 8.75 4.41421 8.75 4V2.25C8.75 1.83579 9.08579 1.5 9.5 1.5ZM13.5 1.5C13.9142 1.5 14.25 1.83579 14.25 2.25V4C14.25 4.41421 13.9142 4.75 13.5 4.75C13.0858 4.75 12.75 4.41421 12.75 4V2.25C12.75 1.83579 13.0858 1.5 13.5 1.5ZM6.21 7.01C4.30305 7.01 2.75 8.55537 2.75 10.47V11.25H17.04V10.47C17.04 8.56421 15.4858 7.01 13.58 7.01H6.21ZM17.9912 8.20401C17.1665 6.60573 15.4984 5.51 13.58 5.51H6.21C3.47695 5.51 1.25 7.72463 1.25 10.47V17.79C1.25 20.5242 3.47579 22.75 6.21 22.75H13.58C16.2213 22.75 18.39 20.6815 18.5325 18.0645C20.916 17.7049 22.75 15.6419 22.75 13.16C22.75 10.4823 20.6315 8.30951 17.9912 8.20401ZM18.54 9.7816V16.5379C20.0873 16.1938 21.25 14.8084 21.25 13.16C21.25 11.5038 20.088 10.124 18.54 9.7816ZM17.04 12.75H2.75V17.79C2.75 19.6958 4.30421 21.25 6.21 21.25H13.58C15.4869 21.25 17.04 19.7046 17.04 17.79V12.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinks);
export default __webpack_public_path__ + "static/media/drinks.4f64f1699df606c26577a49fb830351e.svg";
export { ForwardRef as ReactComponent };